import React, { FC, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, message } from 'antd';
import AssetForm from '../asset_form/AssetForm';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { getAssetCopy } from '../../utils/assetUtils';
import { getLocationSearch } from '../../utils/HistoryUtils';
import { EditPage } from '../edit_page/EditPage';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';

const { Content } = Layout;
const queryString = require('qs');

const NewAssetPage: FC<any> = ({ history, location, getAsset }): React.ReactElement => {
	const [assetFetching, setAssetFetching] = useState(false);
	const [assetData, setAssetData] = useState({});

	// Merge order-independently with whatever the parent fetch may have already
	// written: copied fields are the base, parent-derived fields (parentId,
	// locationId, etc.) win on conflict regardless of which fetch resolves last.
	const copyAssetData = (asset) => setAssetData((prev) => ({ ...getAssetCopy(asset), ...prev }));

	const getAssetData = useCallback(
		(id) => {
			setAssetFetching(true);
			getAsset(id)
				.then(copyAssetData)
				.catch((err) => message.error(err))
				.finally(() => setAssetFetching(false));
		},
		[getAsset]
	);

	const getParentAssetData = useCallback(
		(parentId) => {
			setAssetFetching(true);
			getAsset(parentId)
				.then((parent) =>
					setAssetData((prev) => ({
						...prev,
						parentId: parseInt(parentId, 10),
						locationId: nullSafeGet('locationId', parent),
						areaId: nullSafeGet('areaId', parent),
						images: nullSafeGet('images', parent),
						isLeased: nullSafeGet('isLeased', parent),
						leaseStartDate: nullSafeGet('leaseStartDate', parent),
						leaseEndDate: nullSafeGet('leaseEndDate', parent),
						installDate: nullSafeGet('installDate', parent),
						purchaseDate: nullSafeGet('purchaseDate', parent),
						manufacturer: nullSafeGet('manufacturer', parent),
					}))
				)
				.catch((err) => message.error(err))
				.finally(() => setAssetFetching(false));
		},
		[getAsset]
	);

	useEffect(() => {
		const queryParams = queryString.parse(getLocationSearch(location));
		queryParams.copyFromAssetId && getAssetData(queryParams.copyFromAssetId);
		queryParams.parentId && getParentAssetData(queryParams.parentId);
	}, [getAssetData, getParentAssetData, location]);

	const isSubAsset = !!nullSafeGet('parentId', assetData);

	return (
		<Content>
			<EditPage
				title={isSubAsset ? 'Create Sub Asset' : 'Create Asset'}
				formComponentProps={{
					formData: assetData,
					onSuccess: (rec) => history.push(`/buyer/assets/detail/${rec.id}`),
				}}
				fetching={assetFetching}
				FormComponent={AssetForm}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	asset: getEntityById(ownProps.match.params.id, state.assets),
});

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewAssetPage));
